import { COUNTRIES } from "@/data/countries";

// Best-effort guess of the user's country code from their browser locale(s).
// Returns a code that exists in COUNTRIES, or null.
export function detectCountryCode() {
  try {
    const codes = new Set(COUNTRIES.map((c) => c.code));
    const langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (const l of langs) {
      if (!l) continue;
      let region;
      try { region = new Intl.Locale(l).region; } catch { region = (l.split("-")[1] || ""); }
      region = (region || "").toUpperCase();
      if (region && codes.has(region)) return region;
    }
  } catch (e) {
    /* locale detection unavailable */
  }
  return null;
}
